import React from "react";
import { useTranslation } from "react-i18next";
import "./realTimeProcesses.scss";

function RealTimeProcesses() {

  const { t } = useTranslation()

  return (
    <div className="container-numerous-processes">
      <div className="texts-numerous-processes">
        <h1>{t("corp_chain.realtime_process.title")}</h1>
        <p>{t("corp_chain.realtime_process.section_text")}</p>
      </div>
    </div>
  );
}

export default RealTimeProcesses;
